module.exports = __webpack_public_path__ + "img/select.70bb6705.png";